import { styled } from '@mui/material'
import { IconCircleCheckOutline18 } from 'nucleo-ui-outline-18/components/IconCircleCheckOutline18'
import { ICON_KNOCKOUT_COLOR_PROPERTY } from '../styles'
import type { ComponentProps, JSXElementConstructor } from 'react'

type FilledIcon = JSXElementConstructor<ComponentProps<'svg'> & { size?: string | number }>

/**
 * Nucleo ships no solid circle-check, so this fills the outline one: the disc takes `currentColor`
 * and the tick is knocked out of it. `data-color="color-2"` is Nucleo's own marker for the
 * secondary stroke, so the selector survives the glyph being redrawn as a path.
 *
 * The knockout colour comes from the nearest theme through an inherited custom property, with a
 * white fallback for standalone use. Use the icon with a strong `color`, such as
 * `fg.success.default`, rather than a muted one.
 */
export const CheckCircleFilledOMIcon: FilledIcon = styled(IconCircleCheckOutline18)({
  '& circle': { fill: 'currentColor', stroke: 'currentColor' },
  "& [data-color='color-2']": { stroke: `var(${ICON_KNOCKOUT_COLOR_PROPERTY}, #fff)` },
})
